import styled from 'styled-components';

export const HoldingsCardsStyles = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(20rem, 1fr));
	gap: 0.5rem;

	> .holding {
		overflow: hidden;
		display: flex;
		flex-direction: column;
		padding: 1rem;
		border: 1px solid ${({ theme }) => theme.v3.colors.gray[4]};
		border-radius: 0.25rem;
		background: ${({ theme }) => theme.v3.colors.white[0]};

		&.expanded {
			border-color: ${({ theme }) => theme.v3.colors.blue[6]};
		}

		> .heading {
			display: flex;
			flex-direction: column;
			margin-bottom: 0.75rem;
		}
	}
`;

export const HoldingVestingCardStyles = styled.div`
	margin-top: 0.25rem;
	border: 1px solid ${({ theme }) => theme.v3.colors.gray[4]};
	border-radius: 0.25rem;
	padding: 0.5rem;
`;
